"use client";

import LayoutMenuInsurance from "@/components/Layout/Menu/Insurance";
import React, { type MouseEvent, useCallback, useState } from "react";

import UiWidgetMavaButton from "@/components/Ui/Widget/Mava/Button";

import { SupPopover, SupProtocol, SupProtocolAdd, SupUserCircle, SupVault, SupVaultAdd } from "@repo/core-ui";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { twMerge } from "tailwind-merge";

const extraNavigation = [
  { name: "MY PROTOCOLS", href: "/account/protocols", icon: <SupProtocol className="h-6 w-6 stroke-0" /> },
  { name: "MY VAULTS", href: "/account/vaults", icon: <SupVault className="h-6 w-6 stroke-0" /> },
  { name: "ADD PROTOCOL", href: "/account/protocols/add", icon: <SupProtocolAdd className="h-6 w-6" /> },
  { name: "ADD VAULT", href: "/account/vaults/add", icon: <SupVaultAdd className="h-6 w-6" /> },
];

export default function LayoutMenuAccount() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);
  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
    },
    [anchorEl]
  );
  const pathname = usePathname();

  return (
    <>
      <button
        type="button"
        className={twMerge("btn-icon hover:bg-primary-75 hover:text-neutral-950", (open || pathname.startsWith("/account")) && "opened")}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <span className="sr-only">Account</span>
        <SupUserCircle />
      </button>
      <SupPopover portal anchorEl={anchorEl} open={open} onClickOutside={handleClose} offset={[0, 4]} className="layout-menu-account h-fit border-0.5 border-neutral-600 p-6">
        <nav className="mt-auto flex min-w-[223px] flex-col justify-center space-y-1 whitespace-nowrap">
          {extraNavigation.map(item => (
            <Link
              key={item.name}
              href={item.href}
              onClick={handleClose}
              className="txt-16_24 flex h-12 items-center p-3 text-neutral-900 duration-100 hover:ease-in md:hover:bg-primary-75 md:hover:text-neutral-700 lg:flex"
            >
              <span className="h-10 w-10 p-2">{item.icon}</span>
              <span className="pr-4">{item.name}</span>
            </Link>
          ))}
          <div className="inline-flex h-[.5px] w-full bg-neutral-500" />
          <UiWidgetMavaButton />
          <LayoutMenuInsurance />
        </nav>
      </SupPopover>
    </>
  );
}
